import React, { useState, useEffect,useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { loginCredential, searchCredential, selectedpassengerCredential ,FeeServiceDropdownCredential, redirectToPageCredentials, moduleAndLoginDivDisabled} from '../ReduxState';
import Header from './Header';
import LogoutModel from './LogoutModel';
import DocumentVerificationModal from './DocumentVerificationModal';
import { Button, Modal } from 'react-bootstrap';
import { useHistory, useLocation } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import { fncAssignSearchedCheckboxes, fncGetServiceNameFromCode,fncPageNavigations, shortcutKeyForPage, shortcutKeys, AirportRoles, ServicesAllowed, isInternationalFlight, checkinModule, checkPassengerStatus, haveTravelDocs, fncCheckIfTokenIsExpired, fncCheckSearchedFlightDetailsEmpty, fncFocusElementDependsOnPathLocation, shortcutKeysForPageNavigation, shortcutKeysforHumburgerMenu } from '../Utility/CommonFun.js';
import { fncAddFEE, fncAddSSR, fncGetBookingFromState, fncRemoveFEE, fncGetFeePriceApi, fncGetSSRPriceApi, fncOverrideFee,fncFEE } from '../Utility/ApiCall.js';
import { confirmAlert } from 'react-confirm-alert'; // Import
import * as moment from 'moment';
import MultiSelect from "react-multi-select-component";
import Searchable from 'react-searchable-dropdown';
import Select from 'react-select';
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import FocusLock from "react-focus-lock";


var matchCount = "0";
const w = window.innerWidth;
function Service({ handleSideMenu }) {
        const [focusedIndex, setFocusedIndex] = useState(null); // Track focused checkbox
        const notesRef = useRef(null);
        const selectwaveref = useRef(null);
        const editAmountOFFEEORSSRref = useRef(null);
        const segmentRef = useRef([]);
        const passengerRef = useRef([]);
        const [isDropdownOpen, setIsDropdownOpen] = useState(false);
        const addButtonRef = useRef(null); //add service btn ref
        const [screenWidth, setScreenWidth] = useState(window.innerWidth);
        const selectRef = useRef(null);
        const selectRef1 = useRef(null);
        const serviceFeesRef = useRef(null);
        const accordionRef = useRef(null);
        const waiveref = useRef(null);
        const yesbutton = useRef(null);
        const ServiceRightDivRef = useRef(null);
      const [deletePopup, setdeletePopup] = useState(false);
      const [JourneyKeyforDeleteBaggage, setJourneyKeyforDeleteBaggage] = useState('')
      const [BaggageKeyforDeleteBaggage, setBaggageKeyforDeleteBaggage] = useState('')
      const [PassengerKeyforDeleteBaggage, setPassengerKeyforDeleteBaggage] = useState('');
      

  
  let history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const [triggerModal, settriggerModal] = useState(false);
  const UserRights = useSelector(state => state.login.CheckInRights);
  const UserBoardingRights = useSelector(state => state.login.BoardingRights);
  const RoleCode = useSelector(state => state.login.RoleCode);
  const ReduxFeeServiceDropdown = useSelector(state => state.selectedpassenger.FeeServiceDropdown);
  const [st_ServiceDropdown, setServiceDropdown] = useState([]);
  const [st_PassengerSSRs, setPassengerSSRs] = useState([]);
  const stSearchedRecordData = useSelector(state => state.search.SearchedRecordData);
  const SearchedFlightDetails = useSelector(state => state.search.SearchedFlightDetails);
  const SearchedSelectedPassengerData = useSelector(state => state.selectedpassenger.SelectedPassengerData);
  const [selectedUser, setSelectedUser] = useState("");
  const [show, setShow] = useState(false);
  const [overrideOK, setoverrideOK] = useState(true);
  const [waveOK, setwaveOK] = useState(true);
  const [ShowOverrideTextBox, setShowOverrideTextBox] = useState(false);
  const [st_UserID, setSelectedUSERID] = useState(0);
  const [modalTitle, setModalTitle] = useState("Add");
  const [st_SelectedService, setSelectedService] = useState("");
  const [AddServices, setAddServices] = useState([]);
  const [selectedSegForServices, setSelectedSegForServices] = useState([]);
  const [AddPassenger, setAddPassenger] = useState([]);
  const [AddSegment, setSegments] = useState([]);
  const [selectedDiv, setSelectedDiv] = useState(0);
  const [feeAmount, setfeeAmount] = useState("");
  const [AddButtonDisabled, setAddButtonDisabled] = useState(true);
  const [st_notes, setNotes] = useState("");
  const [st_feesOrSSR, setFeesOrSSR] = useState("");
  const [OverrideReasonTextBox, setOverrideReasonTextBox] = useState("");
  const [ShowWaveTextBox, setShowWaveTextBox] = useState(false);
  const [WaveReasonTextBox, setWaveReasonTextBox] = useState("");
  const [st_SearchabledropdownValue,setSearchabledropdownValue] = useState("");
  const [storedFEEANDSSRArray, setstoredFEEANDSSRArray] = useState([]); // for storing fee and ssr temporarily in localstorage
  const [showDeletePopUp, setshowDeletePopUp] = useState(false);
  const selectedModule = useSelector(state => state.login.Module);
  const docVerified = useSelector(state => state.docVerify.documentsVerified);
  const IsModulAndLoginDivDisabled = useSelector(state => state.login.IsModulAndLoginDivDisabled);
// console.log('.seat-container .rightDetail-data', AddServices);
  // 0 FOR NOTHING
  // 1 FOR ONLY AMOUNT IN FEE
  // 2 FOR COMPLETE FEE
  // 3 FOR COMPLETE SSR
  // console.log('service component=====', isInternationalFlight(SearchedFlightDetails), selectedModule, docVerified);
  const [selectedSegments, setSelectedSegments] = useState([]);
  const [selectedPassengerDropdown, setSelectedPassengerDropdown] = useState([]);


  // Edit DATA STATE
  const [editSegments, seteditSegments] = useState("");
  const [editSSRORFEE, seteditSSRORFEE] = useState("");
  const [editAmountOFFEEORSSR, seteditAmountOFFEEORSSR] = useState("");
  const [editIsWaveAllowed, seteditIsWaveAllowed] = useState("");

  // WAIVE OR OVERRIDE 
  //  1. EDIT
  //  2. WAIVE
  //  3. OVERRIDE
  const [editWaveOverrideOrDisplay, seteditWaveOverrideOrDisplay] = useState(1);
  const [AddServiceFocuslockDisable, setAddServiceFocuslockDisable] = useState(false);



  const notify = (e) =>
    toast.error(e, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });

  const notifySuccess = (e) =>
    toast.success(e, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });


    let allCheckedIn = false;

    if (!isInternationalFlight(SearchedFlightDetails) && selectedModule === checkinModule) {
      const passengersForPnr = { ...SearchedFlightDetails };
      const passengerArr = passengersForPnr.passenger.filter(p => p.IsSelected);
      let selectedPassengers = passengerArr;
      allCheckedIn = selectedPassengers.filter(p => p.passengerKey).every(p => checkPassengerStatus(SearchedFlightDetails, SearchedSelectedPassengerData, p));
    }
 
  useEffect(() => {

       
    // debugger
    // var passengerArray = SearchedFlightDetails.passenger;
    // let selectedSeg = SearchedFlightDetails.journeys.map((j) => j.segments.filter(seg => seg.IsSelected));
    // selectedSeg = [].concat(...selectedSeg);
    // const selectedSegForServices = selectedSeg.map(s => s.flightReference);
   
    // i was getting errr undefined map
    const passengerArray = SearchedFlightDetails?.passenger || []; // Ensure passengerArray is an array

const selectedSeg = (SearchedFlightDetails?.journeys || [])
  .map(j => j.segments.filter(seg => seg.IsSelected))
  .flat(); // Flatten the array
    const selectedSegForServices = selectedSeg.map(s => s.flightReference);
    passengerArray.forEach((val, j) => {
      val.fees.forEach((fee, i) => {
        fee.IsDeleteAble = false;
        fee.IsWaveOrOverride = false;
      })
    })

    for (var i = 0; i < passengerArray.length; i++) {
      for (var j = 0; j < passengerArray[i].fees.length; j++) {
        if (parseInt(passengerArray[i].fees[j].totalAmount) == 0) {
          passengerArray[i].fees[j].IsDeleteAble = true;
        }
        else {
          passengerArray[i].fees[j].IsWaveOrOverride = true;
        }

        var storedData = JSON.parse(localStorage.getItem('TemporaryFEEANDSSRData'));
        if (storedData != null) {
          for (var k = 0; k < storedData.length; k++) {
            if (storedData[k] == passengerArray[i].fees[j].code) {
              passengerArray[i].fees[j].IsDeleteAble = true;
            }
          }
        }

      }
    }
    setSelectedSegForServices(selectedSegForServices);
    setAddServices(passengerArray);
  }, [SearchedFlightDetails])

  /** effect for opening/closing side menu using shortcut keys (ALT + e)  */
  useEffect(() => {
    document.addEventListener("keydown", function (event) {  
      if (event.altKey && (event.key === 'Dead' || event.key === 'e')) {
        handleSideMenu();
      }
    })
  });

  useEffect(() => {
    let input = document.getElementsByClassName("clsTextBoxEnterClick");
    if(input.length > 0) {
        input = input[0];
        input.addEventListener("keyup", function (event) {
            if (event.key === 'Enter') {
                event.preventDefault();
                document.getElementById("btnAddOrEdit").click(); 
            }
        });
    } 
   
}, []);

  useEffect(() => {
      if (fncCheckSearchedFlightDetailsEmpty(SearchedFlightDetails)) {
          history.push('/Search');
      }
  });

  useEffect(() => {
            document.addEventListener("keydown", shortcutKeyHandler);
            return () => {
                document.removeEventListener('keydown', shortcutKeyHandler);
            };
        });
    
        const shortcutKeyHandler = (event) => {
            const tag = event.target.tagName.toLowerCase();
            const isTypingField = tag === 'input' || tag === 'textarea' || event.target.isContentEditable;
            if(shortcutKeysForPageNavigation.includes(event.key)){
                const path = shortcutKeyForPage(location.pathname, event, SearchedFlightDetails);
                if (path) {
                    history.push('/' + path);
                }
            }
            if (isTypingField && !event.ctrlKey) return;
            if (event.ctrlKey  && shortcutKeys.includes(event.key)) {
                if (shortcutKeysforHumburgerMenu.includes(event.key)) {
                        dispatch(redirectToPageCredentials(
                                    {
                                      type: "",
                                      redirectionPage: location.pathname
                                    }
                         ));
                }
                const path = shortcutKeyForPage(location.pathname, event);
                if (path) {
                    history.push('/' + path);
                }
            }                          
        }

  function fncNextButtonFocus() {
    document.getElementById("fncNextButtonService").focus();
  }
  useEffect(() => {
       
    fncNextButtonFocus();
       debugger
    setAddServices(SearchedFlightDetails.passenger);
        //--------------------------------------------------------------- creating dropdown for passengers --------------------------------
        var passengers = SearchedFlightDetails?.passenger || [];
    var arrpassengers = [];
    for (var i = 0; i < passengers.length; i++) {
      if (passengers[i].IsSelected == true) {
        arrpassengers.push({
          "label": passengers[i].name.first + " " + passengers[i].name.last,
          "value": passengers[i].name.first + " " + passengers[i].name.last,
          "FirstName": passengers[i].name.first,
          "LastName": passengers[i].name.last,
          "passengerKey": passengers[i].passengerKey

        })
      }
    }

    setAddPassenger(arrpassengers);
    if (arrpassengers.length == 1) {
      setSelectedPassengerDropdown(arrpassengers);
    }
    //-------------------------------------------------------------- creating dropdown for segments- ---------------------
    var segmentDropdown = [];
    var trip = [];
    var vSegementDetails = SearchedFlightDetails.journeys;

    for (var i = 0; i < vSegementDetails.length; i++) {
      var segments = vSegementDetails[i].segments;
      for (var j = 0; j < segments.length; j++) {
        if (segments[j].IsSelected == true) {
          segmentDropdown.push({
            "label": segments[j].identifier.carrierCode + " " + segments[j].identifier.identifier + " " + segments[j].designator.origin + " " + segments[j].designator.destination,
            "value": segments[j].identifier.carrierCode + " " + segments[j].identifier.identifier + " " + segments[j].designator.origin + " " + segments[j].designator.destination + " " + segments[j].designator.departure,
            "carrierCode": segments[j].identifier.carrierCode,
            "identifier": segments[j].identifier.identifier,
            "origin": segments[j].designator.origin,
            "destination": segments[j].designator.destination,
            "departure": segments[j].designator.departure
          })

          trip.push(
          {
            "identifier": {
              "identifier": segments[j].identifier.identifier,
              "carrierCode": segments[j].identifier.carrierCode,
              "opSuffix": ""
            },
            "destination": segments[j].designator.destination,
            "origin": segments[j].designator.origin,
            "departureDate": segments[j].designator.departure
          }
        )
        }
      }
    }

    setSegments(segmentDropdown);

    if (segmentDropdown.length == 1) {
      setSelectedSegments(segmentDropdown)
    }

    // debugger;


// --------------------------------------- new implementation on 9 dec 2021 -----------------------------------------

   
                              fncFEE()
                                .then((returnVal) => {
                                        if (returnVal.status == "401" && returnVal.data == "") {
                                                document.getElementById("showAndHideSpinner").style.display = "none";
                                                settriggerModal(true);
                                        }
                                        else {
                                                if (returnVal.data.isError == false) {
                                                  // debugger;

                                                        var fees = returnVal.data.fees;
                                                         
                                                        var vSearchedFlightDetails = SearchedFlightDetails;
                                                        const vSearchedSelectedPassengerData = SearchedSelectedPassengerData;


                                                        
                                                        var passengerArray = [vSearchedFlightDetails.passenger[0].passengerKey];
                                                        
                                                        var data = {
                                                          "trips": trip,
                                                          "passengerKeys": passengerArray,
                                                          "currencyCode": "INR"
                                                        }
                                                  
                                                        fncGetSSRPriceApi(data)
                                                          .then((returnVal) => {
                                                            // debugger;
                                                  
                                                            document.getElementById("showAndHideSpinner").style.display = "none";
                                                  
                                                            if (returnVal.status == "401" && returnVal.data == "") {
                                                              settriggerModal(true);
                                                            }
                                                            else {
                                                              if (returnVal.data.isError == false) {
                                                             
                                                                var FeeServiceDropDown = fees.concat(returnVal.data.ssrAvailabilityResponse.segmentSsrs[0].ssrs);
                                                                setPassengerSSRs(returnVal.data.ssrAvailabilityResponse.segmentSsrs[0].ssrs);
                                                                // debugger;

                                                                var options = []  
                                                                for(var i=0; i<FeeServiceDropDown.length; i++)
                                                                {
                                                                  if( FeeServiceDropDown[i].ssrCode == undefined)
                                                                  {
                                                                      options.push({
                                                                        "value":"FEE_" + FeeServiceDropDown[i].feeCode + '_' + FeeServiceDropDown[i].feeApplication,
                                                                        "id":"FEE_" + FeeServiceDropDown[i].feeCode + '_' + FeeServiceDropDown[i].feeApplication,
                                                                        "label" :"FEE " + FeeServiceDropDown[i].name + " (" + FeeServiceDropDown[i].feeCode + ")" 
                                                                      })     
                                                                  }
                                                                  else{
                                                                    options.push({
                                                                      "id":"SSR_" + FeeServiceDropDown[i].ssrCode,
                                                                      "value":"SSR_" + FeeServiceDropDown[i].ssrCode,
                                                                      "label":"SSR " + FeeServiceDropDown[i].name + " (" + FeeServiceDropDown[i].ssrCode + ")"         
                                                                    })
                                                                  }
                                                                }

                                                                setServiceDropdown(options);

                                                                dispatch(FeeServiceDropdownCredential(
                                                                        {
                                                                                type: "",
                                                                                FeeServiceDropdown: FeeServiceDropDown
                                                                        }))
                                                                
                                                              }
                                                              else {
                                                                document.getElementById("showAndHideSpinner").style.display = "none";
                                                                notify(returnVal.data.errorDetail.errorMessage);
                                                              }
                                                            }
                                                          })
                                                          .catch(err => console.log("Axios err: ", err))                                                     
                                                }
                                                else {
                                                        document.getElementById("showAndHideSpinner").style.display = "none";
                                                        if (fncCheckIfTokenIsExpired(returnVal.data.errorDetail)) {
                                                                settriggerModal(true);
                                                        } else {
                                                                notify(returnVal.data.errorDetail.errorMessage);
                                                        }
                                                }
                                        }
                                })
                                .catch(err => console.log("Axios err: ", err))
              

//--------------------------------------------------------------------------------------------------------------------


    
       
   
  }, []);

  function fncOverrideReason(e) {
    setoverrideOK(false);
    setOverrideReasonTextBox(e.target.value);
  }
  function fncWaveReason(e) {
    setwaveOK(false);
    setWaveReasonTextBox(e.target.value);
  }

  function fncDelete(PassengerFeeKey, code) {
        setdeletePopup(true);
        setJourneyKeyforDeleteBaggage(code);
        // setBaggageKeyforDeleteBaggage(Baggagekey);
        setPassengerKeyforDeleteBaggage(PassengerFeeKey);
        setshowDeletePopUp(true);

        // fncNextButtonFocus();
    // confirmAlert({
    //   customUI: ({ onClose }) => {
    //     return (
    //       <div className='custom-ui'>
    //         <h1>Are you sure?</h1>
    //         <p>You want to delete ?</p>
    //         <button onClick={onClose}>No</button>
    //         <button
    //           onClick={() => {
    //             fnchandleClickDelete(PassengerFeeKey, code);
    //             onClose();
    //           }}
              
    //         >
    //           Yes, Delete it!
    //         </button>
    //       </div>
    //     );
    //   },
    //   closeOnEscape: true,
    //   closeOnClickOutside: true,
    // });

    // confirmAlert({
    //   title: "Are you sure?",
    //   message: "You want to delete ?",
    //   buttons: [
    //     {
    //       label: "No",
    //       className: "cancel-btn",
    //       onClick: () => closeConfirm(),
    //       tabIndex: 0
    //     },
    //     {
    //       label: "Yes, Delete it!",
    //       onClick: () =>  {
    //         fnchandleClickDelete(PassengerFeeKey, code);
    //         closeConfirm();
    //       },
    //       className: "confirm-btn", // Add class for keyboard focus
    //       tabIndex: 0
    //     },
        
    //   ],
    //   afterClose: closeConfirm, // Ensure cleanup,
    //   // closeOnEscape: true,
    //   // closeOnClickOutside: true,
    // });

    // Add event listener for keyboard navigation
    // document.addEventListener("keydown", handleKeyPressForCustomPopup);
  }

  const handleDeleteConfirm = () => {
    fnchandleClickDelete(PassengerKeyforDeleteBaggage,JourneyKeyforDeleteBaggage);
    setshowDeletePopUp(false);
  };

  const handleKeyPressForCustomPopup = (event) => {
    if (event.key === "Enter") {
      // If "No" button is focused, trigger its click event
      if (document.activeElement.classList.contains("cancel-btn")) {
        document.querySelector(".cancel-btn")?.click();
      } else {
        document.querySelector(".confirm-btn")?.click();
      }
    } else if (event.key === "Escape") {
      closeConfirm();
    }
  };

  const closeConfirm = () => {
    document.removeEventListener("keydown", handleKeyPressForCustomPopup);
    document.querySelector(".react-confirm-alert")?.remove();
    document.body.classList.remove("react-confirm-alert-body-element")
    // document.querySelector(".react-confirm-alert")?.remove(); // Force close if needed
  };

  // useEffect(() => {
  //       const handleKeyPress = (e) => {
  //         console.log('deletePopup', deletePopup);      
  //         if (deletePopup && e.key === "Enter") {
  //           // onCloseRef.current.focus();
  //           // fnchandleClickDelete(JourneyKeyforDeleteBaggage, BaggageKeyforDeleteBaggage, PassengerKeyforDeleteBaggage);
           
  //           fncDelete(PassengerKeyforDeleteBaggage, JourneyKeyforDeleteBaggage)  // document.getElementById('errorLabelNoOfBags').click();
  //           setBaggageKeyforDeleteBaggage('')
  //           // setPassengerKeyforDeleteBaggage('');
  //           setJourneyKeyforDeleteBaggage('')
  //           //  keyCodeForClose: [13],
  //           setdeletePopup(false)
  //           document.getElementById('react-confirm-alert').remove()
  //         }
  //       };
    
  //       window.addEventListener('keydown', handleKeyPress);
    
  //       return () => {
  //         window.removeEventListener('keydown', handleKeyPress);
  //       };
  //     }, [deletePopup]);

  function fnchandleClickDelete(PassengerFeeKey, code) {
    fncNextButtonFocus();
    var removeFee = [{
      // "signature" : Token,
      "feeKey": PassengerFeeKey
    }
    ]
    fncRemoveFEE(removeFee)
      .then((returnVal) => {
           
        // if ((returnVal.status == "401" && returnVal.data == "") || (returnVal.status == "500"))
        if (returnVal.status == "401" && returnVal.data == "") {
          document.getElementById("showAndHideSpinner").style.display = "none";
          // notify(returnVal.statusText);
          settriggerModal(true);
        }
        else {
          if (returnVal.data.isError == false) {

            var storedData = JSON.parse(localStorage.getItem('TemporaryFEEANDSSRData'));
            if (storedData != null) {
              localStorage.setItem('TemporaryFEEANDSSRData', JSON.stringify(storedData));
            }
            fncSearchApiCallForSeat("Fees is Removed Successfully.");
          }
          else {
            document.getElementById("showAndHideSpinner").style.display = "none";
            if (fncCheckIfTokenIsExpired(returnVal.data.errorDetail)) {
                    settriggerModal(true);
            } else {
                    notify(returnVal.data.errorDetail.errorMessage);
            }
          }
        }
      })
      .catch(err => console.log("Axios err: ", err))
  }

  function fncSearchApiCallForSeat(MES) {
       
    fncNextButtonFocus();
    fncGetBookingFromState()
      .then((returnVal) => {
        // if ((returnVal.status == "401" && returnVal.data == "") || (returnVal.status == "500"))
           

        if (returnVal.status == "401" && returnVal.data == "") {
          document.getElementById("showAndHideSpinner").style.display = "none";
          // notify(returnVal.statusText);
          settriggerModal(true);
        }
        else {
          document.getElementById("showAndHideSpinner").style.display = "none";
          if (returnVal.data.isError == false) {

            if (returnVal.data.flightDetails != null) {
              var assignStateAgain = fncAssignSearchedCheckboxes(SearchedSelectedPassengerData, returnVal.data.flightDetails, "AUTOSEATASSIGN");
              if(w < 1024){
                            setModalTitle('Add');                          
                document.getElementsByClassName('modal-close')[0]?.click();

              }else{
                setModalTitle('Add');
              }

            }

            dispatch(searchCredential(
              {
                type: "",
                SearchedRecordData: stSearchedRecordData,
                SearchedFlightDetails: assignStateAgain
              }
            ));
            if (MES != "") {
              notifySuccess(MES);
            }
          }
          else {
            document.getElementById("showAndHideSpinner").style.display = "none";
            if (fncCheckIfTokenIsExpired(returnVal.data.errorDetail)) {
                    settriggerModal(true);
            } else {
                    notify(returnVal.data.errorDetail.errorMessage);
            }
          }
          document.getElementById("showAndHideSpinner").style.display = "none";
        }

      })
      .catch(err => console.log("Axios err: ", err))
  }

  function fncEditServices(PassengernAME, feesOrSSR) {
    fncNextButtonFocus();
       
    // const [editIsWaveAllowed, seteditIsWaveAllowed] = useState("");
    setShowWaveTextBox(false);
    setWaveReasonTextBox("");
    seteditWaveOverrideOrDisplay(1);
    setShowOverrideTextBox(false);
    setModalTitle('Edit');
    setwaveOK(false);
    setoverrideOK(false);
    setOverrideReasonTextBox("");
    var code = feesOrSSR.code;
    var segment = "";
    //   var segment =feesOrSSR.flightReference!=""? feesOrSSR.flightReference.split(' ')[1]+" "+feesOrSSR.flightReference.split(' ')[2]+" "+
    //  feesOrSSR.flightReference.split(' ')[3].substring(0,3)+"-"+
    //  feesOrSSR.flightReference.split(' ')[3].substring(3,6)
    //  :"";
    var Flightnum = feesOrSSR.flightReference == null ? "" : feesOrSSR.flightReference.replace(/[^0-9]/g, '').substring(8, feesOrSSR.flightReference.replace(/[^0-9]/g, '').length);
    var FlightCode = feesOrSSR.flightReference == null ? "" : feesOrSSR.flightReference.replace(/ /g, '').substring(8, feesOrSSR.flightReference.length - 8).substring(0, 2);
    var FlightOrigin = feesOrSSR.flightReference == null ? "" : feesOrSSR.flightReference.replace(/ /g, '').substring((feesOrSSR.flightReference.replace(/ /g, '').length - 6), feesOrSSR.flightReference.replace(/ /g, '').length).substring(0, 3);
    var FlightDest = feesOrSSR.flightReference == null ? "" : feesOrSSR.flightReference.replace(/ /g, '').substring((feesOrSSR.flightReference.replace(/ /g, '').length - 6), feesOrSSR.flightReference.replace(/ /g, '').length).substring(3, 6);

    if (Flightnum != "") {
      segment = FlightCode + " " + Flightnum + " " + FlightOrigin + "-" + FlightDest;
    }

    // var amount = feesOrSSR.totalAmount;// old
    var amount = fncGettheTotalAmount(feesOrSSR.serviceCharges);
    var isWaveAllowed = feesOrSSR.IsWaveOrOverride;
    var feeORssrName = fncGetServiceNameFromCode(ReduxFeeServiceDropdown, code);
    setNotes("");
    setSelectedUser(PassengernAME);
    seteditSegments(segment);
    seteditSSRORFEE(code + "-" + feeORssrName);
    setFeesOrSSR(feesOrSSR);
    seteditAmountOFFEEORSSR(amount);
    seteditIsWaveAllowed(isWaveAllowed);
    // setSelectedUSERID(UserID);
    setShow(true);
    setTimeout(() => {
      if(isWaveAllowed){
        if (waiveref.current) {
          waiveref.current.focus();
        }
      }else{
        document.getElementById('cancelbtnEditservice').focus();
      }
     }, 100);
  }

  function fncOverrideDropdownChange(e) {
       
    fncNextButtonFocus();
    var SelectedService = e.target.options[e.target.selectedIndex].id;
    setShowOverrideTextBox(false);
    if (SelectedService != "") {
      if (SelectedService == "OTH") {
        // setoverrideOK(false);
        setShowOverrideTextBox(true);
      }
      else {
        setoverrideOK(false);
      }
    }
    else {
      setoverrideOK(true);
    }
  }
  function fncWaiveDropdownChange(e) {
       
    fncNextButtonFocus();
    var SelectedService = e.target.options[e.target.selectedIndex].id;
    setShowWaveTextBox(false);
    if (SelectedService != "") {
      if (SelectedService == "OTH") {
        setShowWaveTextBox(true);
      }
      else {
        setwaveOK(false);
      }
    }
    else {
      setwaveOK(true);
    }
  }
  function fncServiceChange(e) {
       
    // fncNextButtonFocus();
    debugger;
       
    // setSelectedPassengerDropdown([]);

  setSearchabledropdownValue()
    setAddButtonDisabled(true);
    console.log(e);
    var SelectedService = e.id;
    // setSearchabledropdownValue(e.label);
    setSearchabledropdownValue(e);
    // var SelectedService = e.target.options[e.target.selectedIndex].id;

    setSelectedService(SelectedService);
    if (SelectedService.split("_")[0] == "FEE") {
      if (SelectedService.split("_")[2] == "2" || SelectedService.split("_")[2] == "0") {
        // setSelectedPassengerDropdown([]);
        setSelectedDiv(1);
        fncCallFeeAPI(selectedPassengerDropdown, SelectedService, "NOPASS");
      }
      else {
        setSelectedDiv(2);
        setfeeAmount("");
        if (selectedPassengerDropdown.length > 0) {

          fncCallFeeAPI(selectedPassengerDropdown, SelectedService, "WITHPASS");
        }

      }
    }
    else {

      setSelectedDiv(3);
      setfeeAmount("");
      fncCallSSRAPI(selectedPassengerDropdown, SelectedService, selectedSegments);
    }
    //  setSelectedService(SelectedService);

  }

  function fncNotesChange(e) {
       
    if (e.target.id == "Notes") {
      setNotes(e.target.value)
    }
    if (e.target.value == "") {
      setAddButtonDisabled(true)
    }
    else {
      var selectedServiceORFee = st_SelectedService;
      if (selectedServiceORFee != "") {
        if (selectedServiceORFee.split('_')[0] == "FEE" && (selectedServiceORFee.split("_")[2] == "2" || selectedServiceORFee.split("_")[2] == "0")) {
          setAddButtonDisabled(false);
        }
        else if (selectedServiceORFee.split('_')[0] == "FEE" && selectedPassengerDropdown.length > 0) {
          setAddButtonDisabled(false);
        }
        else if (selectedServiceORFee.split('_')[0] != "FEE" && selectedPassengerDropdown.length > 0 && selectedSegments.length > 0) {
          setAddButtonDisabled(false);
        }
      }
    }
  }

  function fncAddNewService() {
       
    fncNextButtonFocus();
    document.getElementById("showAndHideSpinner").style.display = "block";
    if (st_SelectedService.split("_")[0] == "FEE") {
      document.getElementById("showAndHideSpinner").style.display = "block";
      var feeCode = st_SelectedService.split("_")[1];
      var notes = st_notes;
      var selectedPassengers = selectedPassengerDropdown;
      var addFee = [];
      var origin = SearchedFlightDetails.journeys[0].designator.origin;
      if (selectedPassengers.length == 0) {
        addFee.push({
          // "signature" : Token,
          "passengerKey": "",
          "note": notes,
          "origin": origin,
          "feeCode": feeCode,
          "collectedCurrencyCode": "INR"
        })
      }
      else {
        for (var i = 0; i < selectedPassengers.length; i++) {
          addFee.push({
            // "signature" : Token,
            "passengerKey": selectedPassengers[i].passengerKey,
            "note": notes,
            "origin": origin,
            "feeCode": feeCode,
            "collectedCurrencyCode": "INR"
          })
        }
      }
      setShow(false);
      fncAddFEE(addFee)
        .then((returnVal) => {
          // if ((returnVal.status == "401" && returnVal.data == "") || (returnVal.status == "500"))
             

          if (returnVal.status == "401" && returnVal.data == "") {
            document.getElementById("showAndHideSpinner").style.display = "none";
            // notify(returnVal.statusText);
            settriggerModal(true);
          }
          else {
            document.getElementById("showAndHideSpinner").style.display = "none";
            if (returnVal.data.isError == false) {

              // document.getElementById("modalClose").click();
              if (returnVal.data.addFeeResponses[0].isFeeAdded == true) {
                var storeFeeAndSSRdata = JSON.parse(localStorage.getItem('TemporaryFEEANDSSRData')) != null ? JSON.parse(localStorage.getItem('TemporaryFEEANDSSRData')) : [];

                if (st_SelectedService.split("_")[2] == "2" || st_SelectedService.split("_")[2] == "0") {
                  storeFeeAndSSRdata.push(feeCode);
                }
                else {
                  for (var i = 0; i < selectedPassengers.length; i++) {
                    storeFeeAndSSRdata.push(feeCode);
                  }
                }
                localStorage.setItem('TemporaryFEEANDSSRData', JSON.stringify(storeFeeAndSSRdata))
                fncSearchApiCallForSeat("Fee added Successfully.");
              }
              else {
                document.getElementById("showAndHideSpinner").style.display = "none";
                notify(returnVal.data.errorDetail.errorMessage);
              }
            }
            else {
              document.getElementById("showAndHideSpinner").style.display = "none";
              if (fncCheckIfTokenIsExpired(returnVal.data.errorDetail)) {
                      settriggerModal(true);
              } else {
                      notify(returnVal.data.errorDetail.errorMessage);
              }
            }
          }
        })
        .catch(err => console.log("Axios err: ", err))
    }
    else {
      document.getElementById("showAndHideSpinner").style.display = "block";

      var sSegments = selectedSegments;
      const selectedPassengers = selectedPassengerDropdown;
      var ssrCode = st_SelectedService.split("_")[1];
      var addSSR = [];
      var requestsType = {};
      var items = [];
      var Requests = [];
      const notes = st_notes;

      for (let i = 0; i < sSegments.length; i++) {
        for (let j = 0; j < selectedPassengers.length; j++) {
          items.push(
            {
              "passengerKey": selectedPassengers[j].passengerKey,
              "ssrCode": ssrCode,
              "inBundle": false,
              "count": 1,
              "note": notes
            }
          )
        }

        requestsType = {
          "type": "Segment",
          "market": {
            "identifier": {
              "identifier": sSegments[i].identifier,
              "carrierCode": sSegments[i].carrierCode
            },
            "destination": sSegments[i].destination,
            "origin": sSegments[i].origin,
            "departureDate": sSegments[i].departure
          },
          "items": items
        }

        Requests.push(
          requestsType
        )
        items = [];

      }


      addSSR =
        [{
          // "signature" : Token,
          "ssrsRequest": {
            "requests": Requests,
            "forceWaveOnSell": false,
            "currencyCode": "INR"
          }
        }
        ];
      setShow(false);
      fncAddSSR(addSSR)
        .then((returnVal) => {
          // if ((returnVal.status == "401" && returnVal.data == "") || (returnVal.status == "500"))
             

          if (returnVal.status == "401" && returnVal.data == "") {
            document.getElementById("showAndHideSpinner").style.display = "none";
            // notify(returnVal.statusText);
            settriggerModal(true);
          }
          else {
            if (returnVal.data.isError == false) {
              // document.getElementById("modalClose").click();
              if (returnVal.data.addSSRResponses[0].isSSRAdded == true) {
                var storeFeeAndSSRdata = JSON.parse(localStorage.getItem('TemporaryFEEANDSSRData')) != null ? JSON.parse(localStorage.getItem('TemporaryFEEANDSSRData')) : [];
                for (var i = 0; i < selectedPassengers.length; i++) {
                  storeFeeAndSSRdata.push(ssrCode);
                }
                localStorage.setItem('TemporaryFEEANDSSRData', JSON.stringify(storeFeeAndSSRdata))
                fncSearchApiCallForSeat("SSR added Successfully.");
              }
              else {
                document.getElementById("showAndHideSpinner").style.display = "none";
                notify(returnVal.data.errorDetail.errorMessage);
              }
            }
            else {
              document.getElementById("showAndHideSpinner").style.display = "none";
              if (fncCheckIfTokenIsExpired(returnVal.data.errorDetail)) {
                      settriggerModal(true);
              } else {
                      notify(returnVal.data.errorDetail.errorMessage);
              }
            }
          }
        })
        .catch(err => console.log("Axios err: ", err))
    }
  }

  function fncPassengerChangeDropdown(e) {
       // debugger;
    // fncNextButtonFocus();
    console.log(e);
    // Get the active element before updating state
    const activeElement = document.activeElement;
    var selectedServiceORFee = st_SelectedService;
    setSelectedPassengerDropdown(e);
    setTimeout(() => {
        if (activeElement && activeElement.type === "checkbox") {
          activeElement.focus();
        }
      }, 0);
      var selectedServiceORFee = st_SelectedService;
    if (e.length > 0) {
      if (selectedServiceORFee.split('_')[0] == "FEE") {
        fncCallFeeAPI(e, selectedServiceORFee, "WITHPASS");
      }
      else {
        fncCallSSRAPI(e, selectedServiceORFee, selectedSegments);
      }
    }
    else {
      setfeeAmount("");
      setAddButtonDisabled(true);
    }
  }
  
  function fncSegmentChangeDropdown(e) {

    // value={selectedSegments}
    // onChange={setSelectedSegments}
       
    fncNextButtonFocus();
    console.log(e);
    var selectedServiceORFee = st_SelectedService;
    setSelectedSegments(e);
    if (e.length > 0) {
      fncCallSSRAPI(selectedPassengerDropdown, selectedServiceORFee, e);
    }
    else {
      setfeeAmount("");
      setAddButtonDisabled(true);
    }
  }

  function fncCallSSRAPI(passenger, selectedServiceORFee, segment) {
       // debugger;
    fncNextButtonFocus();
    if (passenger.length > 0 && segment.length > 0) {


              var SelectedSSR = selectedServiceORFee.split('_')[1];
              var ssrSegment = [];
              ssrSegment = st_PassengerSSRs.filter(record => record.ssrCode === SelectedSSR.toUpperCase())
              var filterededAmount = ssrSegment[0].passengersAvailability[0].price;              
              var amount = parseInt(filterededAmount) * parseInt(passenger.length)
              setfeeAmount("" + amount);
              if (st_notes != "") {
                setAddButtonDisabled(false);
              }

      // document.getElementById("showAndHideSpinner").style.display = "block";
      // var trip = [];
      // var passengerArray = [];
      // for (var i = 0; i < segment.length; i++) {
      //   trip.push(
      //     {
      //       "identifier": {
      //         "identifier": segment[i].identifier,
      //         "carrierCode": segment[i].carrierCode,
      //         "opSuffix": ""
      //       },
      //       "destination": segment[i].destination,
      //       "origin": segment[i].origin,
      //       "departureDate": segment[i].departure
      //     }
      //   )
      // }

      // debugger;
      // for (var i = 0; i < passenger.length; i++) {
      //   passengerArray.push(passenger[i].passengerKey)
      // }
      // var data = {
      //   "trips": trip,
      //   "passengerKeys": passengerArray,
      //   "currencyCode": "INR"
      // }

      // fncGetSSRPriceApi(data)
      //   .then((returnVal) => {
      //     debugger;

      //     document.getElementById("showAndHideSpinner").style.display = "none";

      //     if (returnVal.status == "401" && returnVal.data == "") {
      //       settriggerModal(true);
      //     }
      //     else {
      //       if (returnVal.data.isError == false) {
      //         var SelectedSSR = selectedServiceORFee.split('_')[1];
      //         var ssrSegment = [];
      //         var fileterd = [];
      //         for (var i = 0; i < returnVal.data.ssrAvailabilityResponse.segmentSsrs.length; i++) {
      //           ssrSegment = returnVal.data.ssrAvailabilityResponse.segmentSsrs[i].ssrs.filter(record => record.ssrCode === SelectedSSR.toUpperCase())
      //           if (ssrSegment.length > 0) {
      //             fileterd = ssrSegment;
      //             break;
      //           }
      //         }

      //         var ssrJourney = returnVal.data.ssrAvailabilityResponse.journeySsrs[0].ssrs;

      //         var filterededAmount = 0;
      //         if (fileterd.length > 0) {
      //           filterededAmount = fileterd[0].passengersAvailability[0].price;
      //         }
      //         else {
      //           fileterd = ssrJourney.filter(record => record.feeCode === SelectedSSR.toUpperCase())
      //           filterededAmount = fileterd[0].passengersAvailability[0].price;

      //         }
      // debugger;

      //         var amount = parseInt(filterededAmount) * parseInt(passenger.length)
      //         setfeeAmount("" + amount);
      //         if (st_notes != "") {
      //           setAddButtonDisabled(false);
      //         }
      //       }
      //       else {
      //         document.getElementById("showAndHideSpinner").style.display = "none";
      //         notify(returnVal.data.errorDetail.errorMessage);
      //       }
      //     }
      //   })
      //   .catch(err => console.log("Axios err: ", err))
    }
  }
  function fncCallFeeAPI(passenger, selectedServiceORFee, OPTION) {
       
    fncNextButtonFocus();
    document.getElementById("showAndHideSpinner").style.display = "block";
    var data = "";
    var origin = SearchedFlightDetails.journeys[0].designator.origin;
    if (OPTION == "NOPASS") {
      data = {
        "PassengerKey": "",
        "Origin": origin,
        "CollectedCurrencyCode": "INR",
        "FeeCode": selectedServiceORFee.split('_')[1]
      }
    }
    else {
      data = {
        "PassengerKey": passenger[0].passengerKey,
        "Origin": origin,
        "CollectedCurrencyCode": "INR",
        "FeeCode": selectedServiceORFee.split('_')[1]
      }
    }

    fncGetFeePriceApi(data)
      .then((returnVal) => {
        document.getElementById("showAndHideSpinner").style.display = "none";
        if (returnVal.status == "401" && returnVal.data == "") {
          settriggerModal(true);
        }
        else {
          if (returnVal.data.isError == false) {
            var amount = returnVal.data.feePriceResponse[0].amount;
            if (OPTION == "NOPASS") {
              setfeeAmount("" + amount);
            }
            else {
              var totalAmountForAllPass = parseInt(amount) * parseInt(passenger.length);
              setfeeAmount("" + totalAmountForAllPass);
            }

            if (st_notes != "") {
              setAddButtonDisabled(false);
            }
          }
          else {
            document.getElementById("showAndHideSpinner").style.display = "none";
            if (fncCheckIfTokenIsExpired(returnVal.data.errorDetail)) {
                    settriggerModal(true);
            } else {
                    notify(returnVal.data.errorDetail.errorMessage);
            }
          }
        }
      })
      .catch(err => console.log("Axios err: ", err))
  }

  function fncWaiveORoverride(param) {
       
    fncNextButtonFocus();
    setoverrideOK(true);
    setwaveOK(true);
    setOverrideReasonTextBox("");
    setShowOverrideTextBox(false);
    setShowWaveTextBox(false);
    setWaveReasonTextBox("");
    if (param == "WAIVE") {
      seteditWaveOverrideOrDisplay(2);
    }
    else if (param == "EDIT") {
      seteditWaveOverrideOrDisplay(1);
    }
    else {
      seteditWaveOverrideOrDisplay(3);
    }
  }

  function fncOverrideAmount(WaveOrOverride) {
       
    fncNextButtonFocus();
    var OverrideAmount = editAmountOFFEEORSSR;
    var data = "";
    if (WaveOrOverride == "OV") {
      data = [{
        "feeKey": st_feesOrSSR.passengerFeeKey,
        "amount": parseInt(OverrideAmount),
        "collectedCurrencyCode": "INR"
      }]
    }
    else if (WaveOrOverride == "WA") {
      data = [{
        "feeKey": st_feesOrSSR.passengerFeeKey,
        "amount": 0,
        "collectedCurrencyCode": "INR"
      }]
    }


    fncOverrideFee(data)
      .then((returnVal) => {
           
        // if (returnVal.status == "401" && returnVal.data == "") {
        //   document.getElementById("showAndHideSpinner").style.display = "none";
        //   settriggerModal(true);
        // }
        // else {
        //   if (returnVal.data.isError == false) {

        // document.getElementById("modalClose").click(); 
        if (WaveOrOverride == "WA") {
          // fncCreateComments(returnVal, st_feesOrSSR);
          fncSearchApiCallForSeat("Fee Waived Successfully.");
        }
        else {
          fncSearchApiCallForSeat("Fee Overrided Successfully.");
        }
        // }
        // else {
        //   document.getElementById("showAndHideSpinner").style.display = "none";
        //   notify(returnVal.data.errorDetail.errorMessage);
        // }
        // }
      })
      .catch(err => console.log("Axios err: ", err))

  }

  function fncOnchangeOverrideAmount(e) {
       
    // fncNextButtonFocus();
    var amount = e.target.value;
    seteditAmountOFFEEORSSR(amount);
  }

  function fncNextButtonService() {
       
    // let div = document.querySelector('#addService');
    // let clsContains =  div.classList.contains('show')
    // if(clsContains)
    // { 
    //     document.getElementById("btnAddService").click();
    // }
     var navPage = fncPageNavigations(UserRights,"Services",SearchedFlightDetails)
     history.push("/"+navPage);
    // history.push("/payment");
  }

  function fncGettheTotalAmount(ServiceCharges) {
    // fncNextButtonFocus();
       
    var TotalAmount = 0;
    var ReducedAmount = 0;
    var ActualTotalAmount = 0;
    for (var i = 0; i < ServiceCharges.length; i++) {
      if (ServiceCharges[i].type == "6") {
        TotalAmount = parseInt(ServiceCharges[i].amount);
      }
      else if (ServiceCharges[i].type == "1") {
        ReducedAmount = parseInt(parseInt(ReducedAmount) + parseInt(ServiceCharges[i].amount))
      }
    }

    ActualTotalAmount = TotalAmount - ReducedAmount;
    return ActualTotalAmount;

  }

  function fncAddServiceModal(modalTitle, mobileView = false) {
   if (modalTitle === 'Edit' && mobileView) {
    setTimeout(() => {
      setModalTitle('Add');
    }, 200);
   } else {
    setModalTitle('Add');
   }
    

  }

  function fncIncreaseMatchCount(val) {
    matchCount = val;
  }



  
   // for next page
   useEffect(() => {
        const handleKeyDown = (e) => {
          if (e.ctrlKey && e.key === "ArrowRight") {
            fncNextButtonService();
          }
        };
        document.addEventListener("keydown", handleKeyDown);
        return () => {
          document.removeEventListener("keydown", handleKeyDown);
        };
      }, []); 
        // for back page
        useEffect(() => {
          const handleKeyDown = (e) => {
            if (e.altKey && e.key.toLowerCase() === 'c') {
              if(!IsModulAndLoginDivDisabled){
                setAddServiceFocuslockDisable(false);
                                         dispatch(moduleAndLoginDivDisabled({
                                              type: "MODULE_AND_LOGINDIV_DISABLED",
                                              IsModulAndLoginDivDisabled: true
                                          }));
                                          fncFocusElementDependsOnPathLocation(location.pathname,selectRef.current);
                  }else if (IsModulAndLoginDivDisabled) {
                    setAddServiceFocuslockDisable(true);
                                  const headingDiv = document.querySelector(".modulebtn");            
                                  if (headingDiv) {                  
                                      headingDiv.focus();
                                      dispatch(moduleAndLoginDivDisabled({
                                              type: "MODULE_AND_LOGINDIV_DISABLED",
                                              IsModulAndLoginDivDisabled: false
                                          }));
                                  }
                              }
      }
      else if (e.ctrlKey && e.key === "ArrowLeft") {
              history.goBack();
            }
          };      
          document.addEventListener("keydown", handleKeyDown);      
          return () => {
            document.removeEventListener("keydown", handleKeyDown);
          };
        }, [history,IsModulAndLoginDivDisabled]); 
    // move from roght to left div vice versa
     useEffect(() => {
          const handleKeyDown = (e) => {
            if (e.shiftKey && e.key === "ArrowLeft") {
              setAddServiceFocuslockDisable(true);
              e.preventDefault(); 
              if (accordionRef.current) {
                accordionRef.current.focus(); 
              }
            }
           else
           if (e.shiftKey && e.key === "ArrowRight") {
            console.log(editWaveOverrideOrDisplay,"editWaveOverrideOrDisplay");
            setAddServiceFocuslockDisable(false)
            e.preventDefault(); // Prevent default behavior
          
            if (modalTitle === "Add" && selectRef.current) {
              selectRef.current.focus();
            } 
            else if (modalTitle === "New" && selectRef.current) {
              selectRef.current.focus();
            } 
            else if (modalTitle === "Edit") {
              if(editIsWaveAllowed && waiveref.current){
                if (waiveref.current) {
                  waiveref.current.focus();
                }
              }else if(editWaveOverrideOrDisplay === 3){
                if(editAmountOFFEEORSSRref){
                  editAmountOFFEEORSSRref.current.focus();
                }
              }else
              if(editWaveOverrideOrDisplay === 2){
                if(selectwaveref){
                  selectwaveref.current.focus();
                }
              }
              else{
                console.log(editWaveOverrideOrDisplay,"editWaveOverrideOrDisplay")
                document.getElementById('cancelbtnEditservice').focus();
              }
            }
          }
          
          
          };  
          document.addEventListener("keydown", handleKeyDown);
            return () => {
            document.removeEventListener("keydown", handleKeyDown);
          };
        },[editWaveOverrideOrDisplay,modalTitle,AddServiceFocuslockDisable]);
// useEffect(()=>{
//   const handleKeyDown = (e) => {
//     if (e.shiftKey && e.key === "ArrowRight") {
//          if(editWaveOverrideOrDisplay === 1){
//           if(editAmountOFFEEORSSRref){
//             editAmountOFFEEORSSRref.current.focus();
//           }
//         }
//       }
//           };  
//           window.addEventListener("keydown", handleKeyDown);
//             return () => {
//             window.removeEventListener("keydown", handleKeyDown);
//           };
//         },[editWaveOverrideOrDisplay]);
      // leftdiv  trap focus
          useEffect(() => {
            const handleKeyDown = (e) => {
              if (!accordionRef.current) return;
          
              // Select only `<a>` and `<button>` elements inside the accordion
              const focusableElements = accordionRef.current.querySelectorAll(
                'a, button'
              );
              const focusable = Array.from(focusableElements).filter(
                (el) => !el.disabled && el.offsetParent !== null
              );
          
              if (focusable.length === 0) return; // No focusable elements, exit
          
              const currentIndex = focusable.indexOf(document.activeElement);
              const firstElement = focusable[0];
              const lastElement = focusable[focusable.length - 1];
          
              if (e.key === "Tab") {
                if (e.shiftKey) {
                  // Shift + Tab (Backward)
                  if (document.activeElement === firstElement) {
                    e.preventDefault();
                    lastElement.focus();
                  }
                } else {
                  // Tab (Forward)
                  if (document.activeElement === lastElement) {
                    e.preventDefault();
                    firstElement.focus();
                  }
                }
              }
            };
          
            const container = accordionRef.current;
            if (container) {
              container.addEventListener("keydown", handleKeyDown);
            }
          
            return () => {
              if (container) {
                container.removeEventListener("keydown", handleKeyDown);
              }
            };
          }, []);
          
          const trapFocus1 = (e) => {
          if (!serviceFeesRef.current) return;
      
          const focusableElements = serviceFeesRef.current.querySelectorAll(
            'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
          );
          const firstElement = focusableElements[0];
          const lastElement = focusableElements[focusableElements.length - 1];
      
          if (e.key === "Tab") {
            if (e.shiftKey) {
              // Shift + Tab: Focus on the last element if the first is focused
              if (document.activeElement === firstElement) {
                e.preventDefault();
                lastElement.focus();
              }
            } else {
              // Tab: Focus on the first element if the last is focused
              if (document.activeElement === lastElement) {
                e.preventDefault();
                firstElement.focus();
              }
            }
          }
        };
      
        useEffect(() => {
          if (selectRef.current) {
            selectRef.current.focus();
          }
          const modalDiv = serviceFeesRef.current;
      
          if (modalDiv) {
            modalDiv.addEventListener("keydown", trapFocus1);
          }
      
          return () => {
            if (modalDiv) {
              modalDiv.removeEventListener("keydown", trapFocus1);
            }
          };
        }, []);
    
             // Track window resize
      useEffect(() => {
        const handleResize = () => setScreenWidth(window.innerWidth);
        document.addEventListener("resize", handleResize);
        return () => document.removeEventListener("resize", handleResize);
      });

    // Focus first checkbox when dropdown opens
    useEffect(() => {
      if ( passengerRef.current.length > 0) {
        passengerRef.current[0]?.focus();
      }
    }, []);   
    
    // to go from notes to addbtn
    const handleNotesKeyDown = (e) => {
      if (e.key === "Tab" && document.activeElement.id === "Notes") {
        if (addButtonRef.current) {
          e.preventDefault(); // Prevent default behavior
          addButtonRef.current.focus();
        }
      }
    };
     
    const handleKeyDown1 = (event, index) => {
      const container = segmentRef.current[index];
      if (!container) return;
      setTimeout(() => {
        const clearButton = document.querySelector(".clear-selected-button");
        if (clearButton) {
          clearButton.tabIndex = -1; // Prevent focus on Tab key press
        }
        document.querySelectorAll(".select-item").forEach((label) => {
          label.classList.add("checkbox-input");
        });
      }, 100);//100 to load page completely then the inner conditions/functions will be applied
      const checkboxes = container.querySelectorAll(".checkbox-input");
      const lastIndex = checkboxes.length - 1;
    
      if (checkboxes.length === 0) return;
    
      if (event.key === "Tab") {
        event.preventDefault();
        let nextIndex = event.shiftKey ? (index > 0 ? index - 1 : lastIndex) : (index < lastIndex ? index + 1 : 0);
        // Store focus index
        setFocusedIndex(nextIndex);
        checkboxes[nextIndex]?.classList.add("focused-checkbox");
        checkboxes[nextIndex]?.focus();
      }
    };
    
    const handleKeyDown = (event, index, ref) => {
      const container = ref.current[index];
      if (!container) return;
      const clearButton = document.querySelector(".clear-selected-button");
      if (clearButton) {
        clearButton.tabIndex = -1; // Prevent focus on Tab key press
      }
      setTimeout(() => {
        // const clearButton = document.querySelector(".clear-selected-button");
        // if (clearButton) {
        //   clearButton.tabIndex = -1; // Prevent focus on Tab key press
        // }
        document.querySelectorAll(".select-item").forEach((label) => {
          label.classList.add("checkbox-input");
        });
      }, 100); // Delay to allow page elements to load
    
      const checkboxes = container.querySelectorAll(".checkbox-input");
      const lastIndex = checkboxes.length - 1;
      if (checkboxes.length === 0) return;
    
      if (event.key === "Tab") {
        event.preventDefault();
        let nextIndex = event.shiftKey ? (index > 0 ? index - 1 : lastIndex) : (index < lastIndex ? index + 1 : 0);
    
        setFocusedIndex(nextIndex);
        checkboxes[nextIndex]?.classList.add("focused-checkbox");
        checkboxes[nextIndex]?.focus();
      }
    };
    
    useEffect(() => {
      const clearButton = document.querySelector(".clear-selected-button");
      if (clearButton) {
        clearButton.tabIndex = -1; // Prevent focus on Tab key press
      }
    });
  
            const handleKeyDownForServiceEdit = (e) => {
              if (e.key === "Tab") {
                  const focusableElements = ServiceRightDivRef.current.querySelectorAll(
                      'input, button, [tabindex]:not([tabindex="-1"])'
                  );
                  const firstElement = focusableElements[0];
                  const lastElement = focusableElements[focusableElements.length - 1];
      
                  if (!e.shiftKey && document.activeElement === lastElement) {
                      e.preventDefault();
                      firstElement.focus();
                  } else if (e.shiftKey && document.activeElement === firstElement) {
                      e.preventDefault();
                      lastElement.focus();
                  }
              }
          };

           useEffect(() => {
              const handleKeyDown = (e) => {
              if (e.key === "Tab") {
              if (
              document.activeElement.id === "NoDeleteBtn" && 
              !e.shiftKey
              ) {
              e.preventDefault();
              yesbutton.current?.focus(); 
              }    
              }
              }
              document.addEventListener("keydown", handleKeyDown);
              return () => {
              document.removeEventListener("keydown", handleKeyDown);
              };
              });
          
              useEffect(() => {
                    if (showDeletePopUp) {
                            yesbutton.current.focus();
                    }
              }, [showDeletePopUp]);
    
  return (
    
    <div class="seat-container">
      <LogoutModel trigger={triggerModal}> </LogoutModel>
      <DocumentVerificationModal trigger={!isInternationalFlight(SearchedFlightDetails) && selectedModule === checkinModule && !docVerified && !allCheckedIn && haveTravelDocs(SearchedFlightDetails)}></DocumentVerificationModal>
          <Modal
            show={showDeletePopUp}
            onHide={() => setshowDeletePopUp(false)}
            backdrop="static"
            keyboard={false}
            centered
            dialogClassName="bottom-dialog-modal"
          >
            <Modal.Header>
              <Modal.Title>Are you sure?</Modal.Title>
            </Modal.Header>
          
            <Modal.Body>
              <p>You want to delete?</p>
            </Modal.Body>
          
            <Modal.Footer>
              <Button ref={yesbutton}
                variant="secondary"
                className="confirm-btn OrangeShadow"
                onClick={handleDeleteConfirm}
              >
                  Yes, Delete it!
              </Button>
              <Button id='NoDeleteBtn'
                variant="danger"
                className="cancel-btn OrangeShadow"
                onClick={() => setshowDeletePopUp(false)}
              >
                No
              </Button>
            </Modal.Footer>
          </Modal>
            <div class="row" inert>
                <div class="col-lg-8">
                    <div class="leftDetail-data">
                        <div className="pTable-data-outer bagData">
                            <div className="heading">
                                <h4 className="font-xxl bold dark-text mb-0">
                                    Services
                                </h4>
                                <a data-bs-dismiss="modal" data-bs-toggle="modal" data-bs-target="#newService" class="addNewBag-btn d-lg-none d-inline-block btn btn-primary">
                                  New Service
                                </a>
                            </div>
                            <div class="pTable border-t-1">
                                <div class="accordion pTableAccordion OrangeShadow" id="accordionExample" tabIndex={-1} ref={accordionRef}>
                                  
                                  {
                                  AddServices.length == 0 ? "" : AddServices.map((item, i) =>
                                  item.IsSelected == true ?
                                  <div class="accordion-item" key={i}>
                                        <h2 class="accordion-header" id={`heading${item.name.first}`}>
                                            <a class="accordion-button btn-animtion focusClass" type="button" data-bs-toggle="collapse" data-bs-target={`#collapse${item.name.first}`} aria-expanded="true" aria-controls={`collapse${item.name.first}`}tabIndex={0}
                                            onKeyDown={(e) => {
                                                if (e.key === "Enter") {
                                                  const allButtons = document.querySelectorAll(".accordion-button");
                                                  const allCollapseElements = document.querySelectorAll(".collapse");
                                                  const currentButton = e.currentTarget;
                                                  const target = document.querySelector(`#collapse${item.name.first}`);
                                            
                                                  // add 'collapsed' class from all buttons
                                                  allButtons.forEach((btn) => btn.classList.add("collapsed"));
                                             
                                                  // Hide all collapse elements except the target
                                                  allCollapseElements.forEach((element) => {
                                                    if (element.id !== `collapse${item.name.first}`) {
                                                      element.classList.remove("show");
                                                    }
                                                  });
                                            
                                                  if (target) {
                                                    target.classList.toggle("show");
                                                    currentButton.classList.toggle("collapsed", !target.classList.contains("show"));
                                                  }
                                                }
                                              
                                              }}>
                                            {item.name.last + "," + item.name.first + " " + item.name.title}
                                            </a>
                                            
                                        </h2>
                                        <div id={`collapse${item.name.first}`} class="accordion-collapse collapse show" aria-labelledby={`heading${item.name.first}`} data-bs-parent="#accordionExample">
                                            <div class="accordion-body">
                                                <div class="ptable-data">
                                                    <div class="headings">
                                                        <div class="type">Type</div>
                                                        <div class="sName">Service Name</div>
                                                        <div class="price">Price ({SearchedFlightDetails.currencyCode})</div>
                                                        <div class="route">Route</div>
                                                        <div class="note">Note</div>
                                                        <div class="sts">STS</div>
                                                        <div class="action">Action</div>
                                                    </div>
                                                    {item.fees.length == 0 ? "" : item.fees.map((service, j) =>
                                                    
                                                    (service.type === 'ServiceFee') || (service.flightReference && selectedSegForServices.includes(service.flightReference)) ?
                                                    <div class="pTable-scroll-body mb-0">
                                                          <div class="table-item service-item">
                                                              <div class="type">
                                                                  <label>Type</label>
                                                                  <p>{service.code} </p>
                                                              </div>
                                                              <div class="sName">
                                                                  <label>Service Name</label>
                                                                  <p>{fncGetServiceNameFromCode(ReduxFeeServiceDropdown, service.code)}</p>
                                                              </div>
                                                              <div class="price"> <label>Price ({SearchedFlightDetails.currencyCode})</label>
                                                                  <p>{fncGettheTotalAmount(service.serviceCharges)}</p>
                                                              </div>
                                                              <div class="route"> <label>Route</label>
                                                                  <p>
                                                                  {
                                                                    service.flightReference == null ? "" :
                                                                      service.flightReference.replace(/ /g, '').substring((service.flightReference.replace(/ /g, '').length - 6), (service.flightReference.replace(/ /g, '').length - 3))
                                                                      + "-" +
                                                                      service.flightReference.replace(/ /g, '').substring((service.flightReference.replace(/ /g, '').length - 3), (service.flightReference.replace(/ /g, '').length))
                                                                  }
                                                                  </p>
                                                              </div>
                                                              <div class="note"> <label>Note</label>
                                                                  <p><img data-bs-toggle="tooltip" data-bs-html="true" title={service.note == null ? "" : service.note.length < 4 ? service.note : service.note.substring(0, 3) + ".."} class="icon-20" src="newImages/icon-note.svg" alt="note"
                                                                      /></p>
                                                              </div>
                                                              <div class="sts"> <label>STS</label>
                                                                  <p>{service.overrides == false ? " " : "OV"}</p>
                                                              </div>
                                                              {
                                                                ((ServicesAllowed.includes(service.code) && AirportRoles.includes(RoleCode)) ||
                                                                !AirportRoles.includes(RoleCode)) ?
                                                                <div class="action">
                                                                  <button tabIndex={0}
                                                                  class="icon-btn focusClass checkbox-input"
                                                                  {...(w <= 1024 ? { "data-bs-toggle": "modal", "data-bs-target": "#newService" }: {})}
                                                                  
                                                                  onClick={() => { fncEditServices(item.name.last + "," + item.name.first + " " + item.name.title, service) }}
                                                                  title="Edit"
                                                                  >
                                                                    <img src="newImages/icon-edit.svg" />
                                                                  </button>
                                                                  {
                                                                    service.IsDeleteAble == true ?
                                                                    <button class="icon-btn focusClass checkbox-input" tabIndex={0} data-bs-toggle="tooltip" data-bs-html="true" onClick={() => { fncDelete(service.passengerFeeKey, service.code) }} title="Delete"><img src="newImages/icon-delete.svg" /></button>
                                                                    :
                                                                    ""
                                                                  }                                                          
                                                                </div> : <div class="action"></div>
                                                              }
                                                          </div> 
                                                      </div>
                                                      : null
                                                    )}
                                                    {SearchedFlightDetails.journeys.length == 0 ? "" : SearchedFlightDetails.journeys.map((jou, i) => jou.segments.length == 0 ? "" : jou.segments.map((seg, j) => seg.IsSelected == false ? "" : seg.passengerSegment.length == 0 ? "" : seg.passengerSegment.map((passseg, k) => passseg.IsSelected == false ? "" : item.passengerKey != passseg.passengerKey ? "" : passseg.ssrs.length == 0 ? "" : passseg.ssrs.map((ssrs, k) =>
                                                    <div>
                                                      {
                                                        item.fees.length == 0 ? "" : item.fees.map((fee, l) => fee.code == ssrs.ssrCode ? fncIncreaseMatchCount("1") : ""
                                                        )
                                                      }
                                                      {
                                                        matchCount === 0 ?
                                                        <div class="pTable-scroll-body mb-0">
                                                          <div class="table-item service-item">
                                                              <div class="type">
                                                                  <label>Type</label>
                                                                  <p>{ssrs.ssrCode} </p>
                                                              </div>
                                                              <div class="sName">
                                                                  <label>Service Name</label>
                                                                  <p>{fncGetServiceNameFromCode(ReduxFeeServiceDropdown, ssrs.ssrCode)}</p>
                                                              </div>
                                                              <div class="price"> <label>Price ({SearchedFlightDetails.currencyCode})</label>
                                                                  <p>0</p>
                                                              </div>
                                                              <div class="route"> <label>Route</label>
                                                                  <p>
                                                                  
                                                                  </p>
                                                              </div>
                                                              <div class="note"> <label>Note</label>
                                                                  <p><img data-bs-toggle="tooltip" data-bs-html="true" class="icon-20" src="newImages/icon-note.svg" alt="note"
                                                                      /></p>
                                                              </div>
                                                              <div class="sts"> <label>STS</label>
                                                                  <p>WV</p>
                                                              </div>
                                                              <div class="action">
                                                                  
                                                              </div>
                                                          </div> 
                                                        </div>
                                                        :
                                                        fncIncreaseMatchCount('0')
                                                      }
                                                    </div>
                                                    ))))}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    : ""
                                  )
                                  } 
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 d-none d-lg-block pt-2" ref={ServiceRightDivRef} onKeyDown={handleKeyDownForServiceEdit}>
                  {
                    modalTitle === "Edit" ?
                    editWaveOverrideOrDisplay == 1 ?
                    <div class="serviceFees pe-3">
                      <button id='cancelbtnEditservice' onClick={() => { fncAddServiceModal(modalTitle, false) }} class="btn btn-primary addServiceTop btn-animation SerachBtn">
                            <span class="px-4">CANCEL</span>
                        </button>
                        <h4 class="font-xxl bold dark-text mb-3">{modalTitle === 'Add' ? 'New' : 'Edit'} Service</h4>
                        <div class="bagform">
                            <div class="form-floating mb-4">
                                {/* <input type="text" class="form-control" value="Mr. A Singh" id="fname" placeholder="First Name" /> */}
                                <div class="form-control">{selectedUser}</div>
                                <label class="bold" for="fname">Passenger Name</label>
                            </div>

                            <div class="form-floating mb-4">
                                {/* <select class="form-select" id="serviceFee" aria-label="serviceFee">
                                            <option>Select a Service</option>
                                            <option value="1">SFBO-SFBO</option>
                                          </select> */}
                              <div class="form-control">{editSSRORFEE}</div>
                              <label class="bold" for="serviceFee">Service or Fee</label>
                            </div>
                            {editSegments == "" ? "" :
                            <div class="form-floating mb-4">
                                {/* <select class="form-select" id="segment" aria-label="segment">
                                            <option>Select a Segment</option>
                                            <option value="1">SFBO-SFBO</option>
                                          </select> */}
                                <div class="form-control">{editSegments}</div>
                                <label class="bold" for="segment">Segment</label>
                            </div>
                            }
                            <div class="d-flex justify-content-between">
                                <p class="mb-0 font-md bold dark-text">Total</p>
                                <p class="mb-0 font-md bold dark-text">{SearchedFlightDetails.currencyCode} {editAmountOFFEEORSSR} </p>
                            </div>
                            {editIsWaveAllowed == true ?
                              <div class="mt-4 d-flex">
                                <button type="button" onClick={() => fncWaiveORoverride("WAIVE")} class="btn btn-primary px-4 d-block text-uppercase me-4 btn-animation SerachBtn" ref={waiveref}>Waive</button>
                                <button type="button" class="btn btn-primary px-4 d-block text-uppercase ml- SerachBtn" onClick={() => fncWaiveORoverride("OVERRIDE")} >Override</button>
                              </div>
                              : ""
                            }

                        </div>
                      
                    </div>
                    : editWaveOverrideOrDisplay === 2 ?
                    <div class="bagDetails">
                      {/* <h4 class="font-xxl bold dark-text mb-3">{modalTitle === 'Add' ? 'New' : 'Edit'} Service</h4> */}
                      <div class="bagform">
                        <div class="form-floating mb-4">
                          <select class="form-select focusClass" id="serviceFee" onChange={e => fncWaiveDropdownChange(e)} required aria-label="serviceFee" ref={selectwaveref}>
                            <option id="">Select the Reason</option>
                            <option id="MAX" >MAX SEAT (MAX)</option>
                            <option id="COM">COMPLIMENTARY (COM)</option>
                            <option id="COR">COURTESY (COR)</option>
                            <option id="SVC">SERVICE RECOVERY (SVC)</option>
                            <option id="OTH">OTHER (OTH)</option>
                          </select>
                          <label class="bold">Reason</label>
                        </div>
                        {
                          ShowWaveTextBox == true ?
                          <div class="form-floating mb-4">
                              <input type="text" required class="form-control" value={WaveReasonTextBox} onChange={(e) => { fncWaveReason(e) }} />
                              <label class="bold" for="Reason">Reason</label>
                          </div>
                          : ""
                        }
                        <div class="d-flex justify-content-between">
                          <p class="mb-0 font-md bold dark-text">Total</p>
                          <p class="mb-0 font-md bold dark-text">{SearchedFlightDetails.currencyCode} 0 </p>
                        </div>
                        <div class=" mt-4 d-flex">
                          <button type="button" id='okbtnServicewave' class="btn btn-primary px-4 d-block w-100 text-uppercase mr-2 btn-animation SerachBtn adjust" disabled={waveOK} onClick={() => fncOverrideAmount("WA")} >OK</button>
                          <button type="button" class="btn btn-primary px-4 d-block w-100 text-uppercase ml-2 btn-animation SerachBtn" onClick={() => fncWaiveORoverride("EDIT")}>BACK</button>
                        </div>
                      </div>
                    </div>
                    :
                    <div class="bagDetails">
                      {/* <h4 class="font-xxl bold dark-text mb-3">{modalTitle === 'Add' ? 'New' : 'Edit'} Service</h4> */}
                      <div class="bagform">
                        <div class="form-floating mb-4">
                          <input type="text" id='inputoverride' required class="form-control focusClass" value={editAmountOFFEEORSSR} onChange={(e) => { fncOnchangeOverrideAmount(e) }} ref={editAmountOFFEEORSSRref} />
                          <label class="bold" for="Reason">Total Price</label>
                        </div>
                        <div class="form-floating mb-4">
                          <select class="form-select focusClass" onChange={e => fncOverrideDropdownChange(e)} required >
                            <option id="">Select the Reason</option>
                            <option id="MAX" >MAX SEAT (MAX)</option>
                            <option id="COM">COMPLIMENTARY (COM)</option>
                            <option id="COR">COURTESY (COR)</option>
                            <option id="SVC">SERVICE RECOVERY (SVC)</option>
                            <option id="OTH">OTHER (OTH)</option>
                          </select>
                          <label class="bold">Reason</label>
                        </div>
                        {
                          ShowOverrideTextBox == true ?
                          <div class="form-floating mb-4">
                              <input type="text" required class="form-control" value={OverrideReasonTextBox} onChange={(e) => { fncOverrideReason(e) }} />
                              <label class="bold" for="Reason">Reason</label>
                          </div>
                          : ""
                        }
                        <div class=" mt-4 d-flex">
                          <button type="button" class="btn btn-primary px-4 d-block w-100 text-uppercase mr-2 btn-animation SerachBtn adjust" disabled={overrideOK} onClick={() => fncOverrideAmount("OV")} >OK</button>
                          <button type="button" class="btn btn-primary px-4 d-block w-100 text-uppercase ml-2 SerachBtn" onClick={() => fncWaiveORoverride("EDIT")}>BACK</button>
                        </div>
                      </div>
                    </div>
                    :
                    <div class="serviceFees">
                      <FocusLock disabled={AddServiceFocuslockDisable}>
                    <div class="rightDetail-data bagDetails-data">
                    <button disabled={AddButtonDisabled} onClick={() => { fncAddNewService(modalTitle) }} class="btn btn-primary addServiceTop btn-animation addService SerachBtn" ref={addButtonRef}>
                            <span class="px-4">{modalTitle} Service</span>
                        </button>
                        <div class="serviceFee">
                            <h4 class="font-xxl bold dark-text mb-3"> {modalTitle === 'Add' ? 'New' : 'Edit'} Service</h4>
                            <div class="bagform">
                                

                                {/* <div class="form-floating mb-4 form-group sp-formField sp-selected">
                                  <Select
                                    placeholder="Select the Fee/Service"
                                    value={st_SearchabledropdownValue}
                                      onChange={e => fncServiceChange(e)}
                                    options={st_ServiceDropdown}
                                  />
                                </div> */}
                                <div class="mt-4 pt-2 passengerSelect">                          
                                <div class="form-group sp-formField sp-selected focasClass">  

                                  <Select ref={selectRef}
                                  placeholder="Select the Fee/Service"
                                        value={st_SearchabledropdownValue}
                                          onChange={e => fncServiceChange(e)}
                                        options={st_ServiceDropdown}
                                      />
                                  {/* <span class="label">SERVICE OR FEE</span> */}
                                </div>
                     
                    </div>
                                {
                                  selectedDiv == 0 ? "" :
                                  selectedDiv == 1 ?
                                  <div>
                                    <div class="form-floating mb-4">
                                      <textarea class="form-control" id="Notes" value={st_notes} onChange={(e) => fncNotesChange(e)} onKeyDown={handleNotesKeyDown}   ref={notesRef}></textarea>
                                      <label class="bold" for="note">Note</label>
                                    </div>

                                    <div class="d-flex justify-content-between">
                                        <p class="mb-0 font-md bold dark-text">Total</p>
                                        <p class="mb-0 font-md bold dark-text">{SearchedFlightDetails.currencyCode} {feeAmount === "" ? "" : feeAmount}</p>
                                    </div>
                                  </div>
                                  :
                                  selectedDiv == 2 ?
                                  <div class="focusClass" tabIndex={-1}>
                                    <div class="form-floating mb-4 focusClass">
                                    <MultiSelect
                                        options={AddPassenger}
                                        value={selectedPassengerDropdown}
                                        onChange={(e) => { fncPassengerChangeDropdown(e) }}
                                        labelledBy="Select the Passenger"
                                        className="form-control input-box focusClass menu-item"
                                        onMenuToggle={(isOpen) => setIsDropdownOpen(isOpen)} // Track dropdown state
                                        ItemRenderer={({ checked, option, onClick, index }) => (
                                          <div className="custom-option focusClass menu-item" key={option.value}>
                                            <label 
                                            // className="checkbox-label"
                                            >
                                            {/* <label className={`checkbox-label ${checked ? "checked-class" : "checkbox-input"}`}> */}
                                              <input
                                                type="checkbox"
                                                className="checkbox-input input-box" // ✅ Class will now be applied correctly
                                                checked={checked}
                                                onChange={onClick}
                                                ref={(el) => {
                                                  passengerRef.current[index] = el;
                                                }}
                                                onKeyDown={(event) => handleKeyDown1(event, index,passengerRef)} // Attach handleKeyDown here ✅

                                                // tabIndex="0"
                                              />
                                              {option.label}
                                            </label>
                                          </div>
                                        )}
                                      />
                                      {/* <input type="text" class="form-control" value="Mr. A Singh" id="fname" placeholder="First Name" /> */}
                                      <label class="bold" for="fname">Passenger Name</label>
                                    </div>
                                    <div class="form-floating mb-4">
                                      <textarea class="form-control" id="Notes" value={st_notes} onChange={(e) => fncNotesChange(e)} placeholder="Note" onKeyDown={handleNotesKeyDown}  ref={notesRef}></textarea>
                                      <label class="bold" for="note">Note</label>
                                    </div>

                                    <div class="d-flex justify-content-between">
                                        <p class="mb-0 font-md bold dark-text">Total</p>
                                        <p class="mb-0 font-md bold dark-text">{SearchedFlightDetails.currencyCode} {feeAmount === "" ? "" : feeAmount}</p>
                                    </div>
                                  </div>
                                  :
                                  selectedDiv == 3 ?
                                  <div>
                                    <div class="form-floating mb-4">
                                    <MultiSelect
                                        options={AddPassenger}
                                        value={selectedPassengerDropdown}
                                        onChange={(e) => { fncPassengerChangeDropdown(e) }}
                                        labelledBy="Select the Passenger"
                                        className="form-control"
                                        onMenuToggle={(isOpen) => setIsDropdownOpen(isOpen)} // Track dropdown state
                                        ItemRenderer={({ checked, option, onClick, index }) => (
                                          <div className="custom-option menu-item">
                                            <input
                                                type="checkbox"
                                                className="checkbox-input input-box" // ✅ Class will now be applied correctly
                                                checked={checked}
                                                                            // ref={passengerRef}
                                                onChange={onClick}
                                                ref={(el) => {
                                                  passengerRef.current[index] = el;
                                                }}
                                                onKeyDown={(event) => handleKeyDown(event, index,passengerRef)} // Attach handleKeyDown here ✅

                                                tabIndex="0"
                                              />
                                            <label>{option.label}</label>
                                          </div>
                                        )}
                                      />
                                      {/* <input type="text" class="form-control" value="Mr. A Singh" id="fname" placeholder="First Name" /> */}
                                      <label class="bold" for="fname">Passenger Name</label>
                                    </div>
                                    <div class="form-floating mb-4">
                                    <MultiSelect
                                        options={AddSegment}
                                        value={selectedSegments}
                                        onChange={(e) => { fncSegmentChangeDropdown(e) }}
                                        displayValue="Select the segment"
                                        className="form-control  menu-item"
                                        ItemRenderer={({ checked, option, onClick, index }) => (
                                          <div className="custom-option  menu-item">
                                            <input
                                                type="checkbox"
                                                className="checkbox-input input-box" // ✅ Class will now be applied correctly
                                                checked={checked}
                                                onChange={onClick}
                                                ref={(el) => {
                                                  segmentRef.current[index] = el;
                                                }}
                                                // onKeyDown={(event) => handleKeyDown(event,index)} // Attach handleKeyDown here ✅
                                                onKeyDown={(event) => handleKeyDown1(event, index,segmentRef)} // Attach handleKeyDown here ✅

                                                tabIndex="0"
                                              />
                                            <label>{option.label}</label>
                                          </div>
                                        )}
                                      /> 
                                      <label class="bold" for="segment">Segment</label>
                                    </div>
                                    <div class="form-floating mb-4">
                                      <textarea class="form-control" id="Notes" value={st_notes} onChange={(e) => fncNotesChange(e)} onKeyDown={handleNotesKeyDown} ref={notesRef}></textarea>
                                      <label class="bold" for="note">Note</label>
                                    </div>
                                    <div class="d-flex justify-content-between">
                                        <p class="mb-0 font-md bold dark-text">Total</p>
                                        <p class="mb-0 font-md bold dark-text">{SearchedFlightDetails.currencyCode} {feeAmount === "" ? "" : feeAmount}</p>
                                    </div>
                                  </div>
                                  : ""
                                }                           
                            </div>
                        </div>
                    </div>
                    </FocusLock>                   
                    </div>
                  }
                    
                </div>
            </div>
            <div class="btn-container mobile-fix-bottom">
                <a class="btn btn-primary-dark" onClick={() => history.goBack()}>
                    <span class="px-4"><span class="icon me-2"><img class=" rotate180" src="newImages/i-arrow-right.svg" /> <img class=" rotate180" src="newImages/i-arrow-right.svg" /></span>Previous</span>
                </a>
                <a class="btn btn-secondary" id="fncNextButtonService" onClick={fncNextButtonService}>
                    <span class="px-4"> Next<span class="icon ms-2"><img src="newImages/i-arrow-right.svg" /> <img src="newImages/i-arrow-right.svg" /></span></span>
                </a>
            </div>
            <div class="modal fade " id="newService" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true" data-bs-backdrop="static" data-dismiss="modal" data-toggle="modal">
                <div class="modal-dialog modal-dialog-centered seat-modal">
                { 
                    modalTitle === "Edit" ?
                    editWaveOverrideOrDisplay == 1 ?
                    <div class="serviceFees pe-3 modal-content px-4">
                      <button data-bs-dismiss="modal" onClick={() => { fncAddServiceModal(modalTitle, true) }} class="btn btn-primary addServiceTop modal-close SerachBtn">
                        <span class="px-4">CANCEL</span>
                      </button>
                      <h4 class="font-xxl bold dark-text mb-3">{modalTitle === 'Add' ? 'New' : 'Edit'} Service</h4>
                      <div class="bagform">
                          <div class="form-floating mb-4">
                              {/* <input type="text" class="form-control" value="Mr. A Singh" id="fname" placeholder="First Name" /> */}
                              <div class="form-control">{selectedUser}</div>
                              <label class="bold" for="fname">Passenger Name</label>
                          </div>

                          <div class="form-floating mb-4">
                              {/* <select class="form-select" id="serviceFee" aria-label="serviceFee">
                                          <option>Select a Service</option>
                                          <option value="1">SFBO-SFBO</option>
                                        </select> */}
                            <div class="form-control">{editSSRORFEE}</div>
                            <label class="bold" for="serviceFee">Service or Fee</label>
                          </div>
                          {editSegments == "" ? "" :
                          <div class="form-floating mb-4">
                              {/* <select class="form-select" id="segment" aria-label="segment">
                                          <option>Select a Segment</option>
                                          <option value="1">SFBO-SFBO</option>
                                        </select> */}
                              <div class="form-control">{editSegments}</div>
                              <label class="bold" for="segment">Segment</label>
                          </div>
                          }
                          <div class="d-flex justify-content-between">
                              <p class="mb-0 font-md bold dark-text">Total</p>
                              <p class="mb-0 font-md bold dark-text">{SearchedFlightDetails.currencyCode} {editAmountOFFEEORSSR} </p>
                          </div>
                          {editIsWaveAllowed == true ?
                            <div class="mt-4 d-flex">
                              <button type="button" onClick={() => fncWaiveORoverride("WAIVE")} class="btn btn-primary px-4 d-block text-uppercase me-4" >Waive</button>
                              <button type="button" class="btn btn-outline-primary px-4 d-block text-uppercase ml-2 btn-animation SerachBtn" onClick={() => fncWaiveORoverride("OVERRIDE")} >Override</button>
                            </div>
                            : ""
                          }

                      </div>                      
                    </div>
                    : editWaveOverrideOrDisplay === 2 ?
                    <div class="bagDetails modal-content px-4">
                      {/* <h4 class="font-xxl bold dark-text mb-3">{modalTitle === 'Add' ? 'New' : 'Edit'} Service</h4> */}
                      <div class="bagform">
                        <div class="form-floating mb-4">
                          <select class="form-select" id="serviceFee" onChange={e => fncWaiveDropdownChange(e)} required aria-label="serviceFee">
                            <option id="">Select the Reason</option>
                            <option id="MAX" >MAX SEAT (MAX)</option>
                            <option id="COM">COMPLIMENTARY (COM)</option>
                            <option id="COR">COURTESY (COR)</option>
                            <option id="SVC">SERVICE RECOVERY (SVC)</option>
                            <option id="OTH">OTHER (OTH)</option>
                          </select>
                          <label class="bold">Reason</label>
                        </div>
                        {
                          ShowWaveTextBox == true ?
                          <div class="form-floating mb-4">
                              <input type="text" required class="form-control" value={WaveReasonTextBox} onChange={(e) => { fncWaveReason(e) }} />
                              <label class="bold" for="Reason">Reason</label>
                          </div>
                          : ""
                        }
                        <div class="d-flex justify-content-between">
                          <p class="mb-0 font-md bold dark-text">Total</p>
                          <p class="mb-0 font-md bold dark-text">{SearchedFlightDetails.currencyCode} 0 </p>
                        </div>
                        <div class=" mt-4 d-flex">
                          <button type="button" class="btn btn-primary px-4 d-block w-100 text-uppercase mr-2 SerachBtn adjust" disabled={waveOK} onClick={() => fncOverrideAmount("WA")} >OK</button>
                          <button type="button" class="btn btn-primary px-4 d-block w-100 text-uppercase ml-2 SerachBtn" onClick={() => fncWaiveORoverride("EDIT")} >BACK</button>
                        </div>
                      </div>
                    </div>
                    :
                    <div class="bagDetails modal-content px-4">
                      {/* <h4 class="font-xxl bold dark-text mb-3">{modalTitle === 'Add' ? 'New' : 'Edit'} Service</h4> */}
                      <div class="bagform">
                        <div class="form-floating mb-4">
                          <input type="text" required class="form-control focusClass"  value={editAmountOFFEEORSSR} onChange={(e) => { fncOnchangeOverrideAmount(e) }}/>
                          <label class="bold" for="Reason">Total Price</label>
                        </div>
                        <div class="form-floating mb-4">
                          <select class="form-select focusClass" onChange={e => fncOverrideDropdownChange(e)} required >
                            <option id="">Select the Reason</option>
                            <option id="MAX" >MAX SEAT (MAX)</option>
                            <option id="COM">COMPLIMENTARY (COM)</option>
                            <option id="COR">COURTESY (COR)</option>
                            <option id="SVC">SERVICE RECOVERY (SVC)</option>
                            <option id="OTH">OTHER (OTH)</option>
                          </select>
                          <label class="bold">Reason</label>
                        </div>
                        {
                          ShowOverrideTextBox == true ?
                          <div class="form-floating mb-4">
                              <input type="text" required class="form-control focusClass" value={OverrideReasonTextBox} onChange={(e) => { fncOverrideReason(e) }} />
                              <label class="bold" for="Reason">Reason</label>
                          </div>
                          : ""
                        }
                        <div class=" mt-4 d-flex">
                          <button type="button" class="btn btn-primary px-4 d-block w-100 text-uppercase mr-2 SerachBtn adjust" disabled={overrideOK} onClick={() => fncOverrideAmount("OV")} >OK</button>
                          <button type="button" class="btn btn-primary px-4 d-block w-100 text-uppercase ml-2 SerachBtn" onClick={() => fncWaiveORoverride("EDIT")} >BACK</button>
                        </div>
                      </div>  
                    </div>
                    :  //tab,mobile view
                    <div class="serviceFees modal-content px-4">
                      <div class="rightDetail-data bagDetails-data">
                        <div class="heading">
                          <a data-bs-dismiss="modal" onClick={() => setModalTitle('Add')} class="modal-close">
                              <img src="newImages/i-cross.svg" alt="cross" />
                          </a>
                          <h4 class="font-xxl bold dark-text mb-0">{modalTitle === 'Add' ? 'New' : 'Edit'} Service</h4>
                        </div>
                        <button disabled={AddButtonDisabled} onClick={() => { fncAddNewService(modalTitle) }} class="btn btn-primary mt-3 btn-animation SerachBtn">
                          <span class="px-4">{modalTitle} Service</span>
                        </button>
                        <div class="serviceFee">
                            {/* <h4 class="font-xxl bold dark-text mb-3"> {modalTitle === 'Add' ? 'New' : 'Edit'} Service</h4> */}
                            <div class="bagform">                               

                                {/* <div class="form-floating mb-4 form-group sp-formField sp-selected">
                                  <Select
                                    placeholder="Select the Fee/Service"
                                    value={st_SearchabledropdownValue}
                                      onChange={e => fncServiceChange(e)}
                                    options={st_ServiceDropdown}
                                  />
                                </div> */}
                                <div class="mt-4 pt-2 passengerSelect">                          
                                  <div class="form-group sp-formField sp-selected">  

                                    <Select ref={selectRef1}
                                    placeholder="Select the Fee/Service"
                                          value={st_SearchabledropdownValue}
                                            onChange={e => fncServiceChange(e)}
                                          options={st_ServiceDropdown}
                                        />
                                    {/* <span class="label">SERVICE OR FEE</span> */}
                                  </div>                     
                                </div>
                                {
                                  selectedDiv == 0 ? "" :
                                  selectedDiv == 1 ?
                                  <div>
                                    <div class="form-floating mb-4">
                                      <textarea class="form-control" id="Notes" value={st_notes} onChange={(e) => fncNotesChange(e)}></textarea>
                                      <label class="bold" for="note">Note</label>
                                    </div>

                                    <div class="d-flex justify-content-between">
                                        <p class="mb-0 font-md bold dark-text">Total</p>
                                        <p class="mb-0 font-md bold dark-text">{SearchedFlightDetails.currencyCode} {feeAmount === "" ? "" : feeAmount}</p>
                                    </div>
                                  </div>
                                  :
                                  selectedDiv == 2 ?
                                  <div>
                                    <div class="form-floating mb-4">
                                    <MultiSelect
                                        className="form-control"
                                        options={AddPassenger}
                                        value={selectedPassengerDropdown}
                                        onChange={(e) => { fncPassengerChangeDropdown(e) }}
                                        area-labelledBy="Select the Passenger"

                                        onMenuToggle={(isOpen) => setIsDropdownOpen(isOpen)} 
                                        ItemRenderer={({ checked, option, onClick, index }) => (
                                          <div className="" key={option.value}>
                                              <input
                                                type="checkbox"
                                                checked={checked}
                                                onChange={onClick}
                                                ref={(el) => {
                                                  passengerRef.current[index] = el;
                                                }}
                                                onKeyDown={(event) => handleKeyDown1(event, index,passengerRef)} 
                                              />
                                            <label>{option.label}</label>
                                          </div>
                                        )}
                                      />
                                      <label class="bold" for="fname">Passenger Name</label>
                                    </div>
                                    <div class="form-floating mb-4">
                                      <textarea class="form-control" id="Notes" value={st_notes} onChange={(e) => fncNotesChange(e)} placeholder="Note"></textarea>
                                      <label class="bold" for="note">Note</label>
                                    </div>

                                    <div class="d-flex justify-content-between">
                                        <p class="mb-0 font-md bold dark-text">Total</p>
                                        <p class="mb-0 font-md bold dark-text">{SearchedFlightDetails.currencyCode} {feeAmount === "" ? "" : feeAmount}</p>
                                    </div>
                                  </div>
                                  :
                                  selectedDiv == 3 ?
                                  <div>
                                    <div class="form-floating mb-4">
                                    <MultiSelect
                                        className="form-control"
                                        options={AddPassenger}
                                        value={selectedPassengerDropdown}                                      
                                        onChange={(e) => { fncPassengerChangeDropdown(e) }}
                                        area-labelledBy="Select the Passenger"

                                        onMenuToggle={(isOpen) => setIsDropdownOpen(isOpen)}
                                        ItemRenderer={({ checked, option, onClick, index }) => (
                                          <div  key={option.value}>
                                              <input
                                                type="checkbox"
                                                checked={checked}
                                                onChange={onClick}
                                                ref={(el) => {
                                                  passengerRef.current[index] = el;
                                                }}
                                                onKeyDown={(event) => handleKeyDown1(event, index,passengerRef)}                                               />
                                            <label>{option.label}</label>
                                          </div>
                                        )}
                                    />                                                                    
                                      {/* <input type="text" class="form-control" value="Mr. A Singh" id="fname" placeholder="First Name" /> */}
                                      <label class="bold" for="fname">Passenger Name</label>
                                    </div>
                                    <div class="form-floating mb-4">
                                    <MultiSelect
                                        options={AddSegment}
                                        value={selectedSegments}
                                        onChange={(e) => { fncSegmentChangeDropdown(e) }}
                                        displayValue="Select the segment"
                                        className="form-control"
                                        ItemRenderer={({ checked, option, onClick, index }) => (
                                          <div className="custom-option" key={option.value}>
                                            <input
                                              type="checkbox"
                                              checked={checked}
                                              onChange={onClick}
                                              ref={(el) => (passengerRef.current[index] = el)} // Store reference to checkboxes
                                              onKeyDown={(e) => handleKeyDown(e, index,passengerRef)} // Trap focus inside MultiSelect
                                            />
                                            <label>{option.label}</label>
                                          </div>
                                        )}
                                      /> 
                                      <label class="bold" for="segment">Segment</label>
                                    </div>
                                    <div class="form-floating mb-4">
                                      <textarea class="form-control" id="Notes" value={st_notes} onChange={(e) => fncNotesChange(e)}></textarea>
                                      <label class="bold" for="note">Note</label>
                                    </div>
                                    <div class="d-flex justify-content-between">
                                        <p class="mb-0 font-md bold dark-text">Total</p>
                                        <p class="mb-0 font-md bold dark-text">{SearchedFlightDetails.currencyCode} {feeAmount === "" ? "" : feeAmount}</p>
                                    </div>
                                  </div>
                                  : ""
                                }                           
                            </div>
                        </div>
                      </div>                   
                    </div>
                  }
                    {/* <div class="modal-content">
                        <div class="heading">
                            <a data-bs-dismiss="modal" class="modal-close">
                                <img src="newImages/i-cross.svg" alt="cross" />
                            </a>
                            <h4 class="font-xxl bold dark-text mb-0">{modalTitle === 'Add' ? 'New' : 'Edit'} Service</h4>
                        </div>
                        <div class="bagDetails px-0 py-1">
                            <div class="bagform">
                                <div class="form-floating mb-4">
                                    <input type="text" class="form-control" value="Mr. A Singh" id="fname" placeholder="First Name" />
                                    <label class="bold" for="fname">Passanger Name</label>
                                </div>

                                <div class="form-floating mb-4">
                                    <select class="form-select" id="serviceFee" aria-label="serviceFee">
                                                <option>Select a Service</option>
                                                <option value="1">SFBO-SFBO</option>
                                              </select>
                                    <label class="bold" for="serviceFee">Service or Fee</label>
                                </div>

                                <div class="form-floating mb-4">
                                    <select class="form-select" id="segment" aria-label="segment">
                                                <option>Select a Segment</option>
                                                <option value="1">SFBO-SFBO</option>
                                              </select>
                                    <label class="bold" for="segment">Segment</label>
                                </div>
                                <div class="form-floating mb-4">
                                    <textarea class="form-control" id="note" rows="4" placeholder="Lorem ipsum dolor sit "></textarea>
                                    <label class="bold" for="note">Note</label>
                                </div>

                                <div class="d-flex justify-content-between">
                                    <p class="mb-0 font-md bold dark-text">Total</p>
                                    <p class="mb-0 font-md bold dark-text">{SearchedFlightDetails.currencyCode} 0</p>
                                </div>

                            </div>
                        </div>
                        <div class="btn-container">
                            <a data-bs-dismiss="modal" class="btn btn-primary-dark">
                                <span class="px-4">Close</span>
                            </a>
                            <button class="btn btn-primary addBags-btn">
                                <span class="px-4">Add Service</span>
                            </button>
                        </div>
                    </div> */}
                </div>
            </div>
        </div>
  );
}

export default Service;